var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 112,
    viewBox: "0 0 97 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34",
    x: 34.0337,
    y: 26.6017,
    width: 51.4066,
    height: 72.5648,
    rx: 6.5,
    transform: "rotate(2.5 34.0337 26.6017)",
    fill: "#EEEEEE",
    stroke: "#E1E1E1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    x: 1.04116,
    y: 20.7551,
    width: 57.4066,
    height: 78.5648,
    rx: 9.5,
    transform: "rotate(-7.5 1.04116 20.7551)",
    fill: "white",
    stroke: "#E1E1E1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 24",
    d: "M3.76833 29.978C3.19163 25.5976 6.2752 21.579 10.6557 21.0023L48.7337 15.9892C53.1142 15.4125 57.1328 18.4961 57.7095 22.8766L58.9338 32.1762L4.99265 39.2777L3.76833 29.978Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 68.396,
    y: 17.2117,
    width: 2.26694,
    height: 7.55648,
    rx: 1.13347,
    transform: "rotate(82.5 68.396 17.2117)",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    x: 47.6938,
    y: 4.69369,
    width: 2.26694,
    height: 7.55648,
    rx: 1.13347,
    transform: "rotate(-7.5 47.6938 4.69369)",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 27",
    x: 60.9766,
    y: 6.75586,
    width: 2.26694,
    height: 7.55647,
    rx: 1.13347,
    transform: "rotate(37.5 60.9766 6.75586)",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 28",
    x: 10.6313,
    y: 41.584,
    width: 43.8276,
    height: 3.02259,
    rx: 1.5113,
    transform: "rotate(-7.5 10.6313 41.584)",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    x: 12.604,
    y: 56.5677,
    width: 43.8276,
    height: 3.02259,
    rx: 1.5113,
    transform: "rotate(-7.5 12.604 56.5677)",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 29",
    x: 11.4204,
    y: 47.5776,
    width: 15.8686,
    height: 3.02259,
    rx: 1.5113,
    transform: "rotate(-7.5 11.4204 47.5776)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 31",
    x: 13.3931,
    y: 62.5613,
    width: 15.8686,
    height: 3.02259,
    rx: 1.5113,
    transform: "rotate(-7.5 13.3931 62.5613)",
    fill: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.02ef8e4bfdb6740ef43254a9fd0b9817.svg";
export { ForwardRef as ReactComponent };